import React, { useEffect, useRef } from 'react';
import s from './NewFooter.module.css';
import logo from '../images/לוגו שובל רוימי 1.webp';

const NAV_ITEMS = [
  { label: 'ראשי', href: '#hero' },
  { label: 'אודות', href: '#about' },
  { label: 'תהליך העבודה', href: '#process' },
  { label: 'שירותים', href: '#services' },
  { label: 'פרויקטים', href: '#projects' },
  { label: 'שאלות נפוצות', href: '#faq' },
];

export default function NewFooter() {
  const footerRef = useRef(null);

  useEffect(() => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(s.visible);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className={s.footer} ref={footerRef} id="contact">
      <div className={s.grain} aria-hidden="true" />
      <div className={s.glowA} aria-hidden="true" />
      <div className={s.glowB} aria-hidden="true" />

      {/* ===== Top: Brand + Pull-quote ===== */}
      <div className={s.top}>
        <div className={s.brand}>
          <img src={logo} alt="SRA" className={s.logo} />
          <div className={s.brandText}>
            <span className={s.studioName}>SRA</span>
            <span className={s.studioSub}>סטודיו לאדריכלות ועיצוב פנים</span>
          </div>
        </div>

        <div className={s.quoteCard}>
          <blockquote className={s.quote}>
            <p className={s.quoteText}>
              &ldquo;כל בית שאנחנו מתכננים הוא סיפור של מישהו. התפקיד שלנו - לתת לסיפור הזה מבנה, אור, ומקום לגדול.&rdquo;
            </p>
            <cite className={s.quoteCite}>שובל רוימי אביסרור</cite>
          </blockquote>
        </div>
      </div>

      {/* ===== Middle: 4-column grid ===== */}
      <div className={s.columns}>
        {/* Navigation */}
        <div className={s.col}>
          <h4 className={s.colTitle}>ניווט</h4>
          <ul className={s.navList}>
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className={s.link}
                  onClick={(e) => handleNavClick(e, item.href)}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className={s.col}>
          <h4 className={s.colTitle}>צרו קשר</h4>
          <ul className={s.navList}>
            <li>
              <a href="tel:0544499737" className={s.link}>
                054-449-9737
              </a>
            </li>
            <li>
              <a href="mailto:Shovalr00@gmail.com" className={s.link}>
                Shovalr00@gmail.com
              </a>
            </li>
          </ul>
        </div>

        {/* Social */}
        <div className={s.col}>
          <h4 className={s.colTitle}>עקבו אחרינו</h4>
          <ul className={s.navList}>
            <li>
              <a
                href="https://instagram.com/shoval.roymi"
                className={s.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg className={s.socialIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <rect x="2" y="2" width="20" height="20" rx="5" />
                  <circle cx="12" cy="12" r="5" />
                  <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
                </svg>
                אינסטגרם
              </a>
            </li>
          </ul>
        </div>

        {/* Hours */}
        <div className={s.col}>
          <h4 className={s.colTitle}>שעות פעילות</h4>
          <ul className={s.navList}>
            <li>
              <span className={s.hoursText}>א׳-ה׳ 09:00-18:00</span>
            </li>
            <li>
              <span className={s.locationText}>באר שבע, ישראל</span>
            </li>
          </ul>
        </div>
      </div>

      {/* ===== Bottom bar ===== */}
      <div className={s.bottom}>
        <span className={s.copyright}>
          &copy; 2025 סטודיו SRA &mdash; כל הזכויות שמורות
        </span>
        <span className={s.madeWith}>נבנה עם אהבה</span>
      </div>
    </footer>
  );
}
